package de.oevbs.kunde.kundenportal2.authentication

import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import dev.fritz2.core.Inspector
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.Validation
import dev.fritz2.validation.validation

@Lenses
data class UserLoginData(
    val username: String = "",
    val password: String = ""
) {
    companion object {
        val validation: Validation<UserLoginData, Unit, ComponentValidationMessage> = validation { inspector, _ ->
            val user: Inspector<String> = inspector.map(UserLoginData.username())
            if (user.data.isEmpty()) {
                add(user.errorMessage(KupoValidationMessages.EMPTY_INPUT))
            }

            val pass: Inspector<String> = inspector.map(UserLoginData.password())
            if (pass.data.isEmpty()) {
                add(pass.errorMessage(KupoValidationMessages.EMPTY_INPUT))
            }
        }
    }
}



